import { createFrontendClient } from '@pipedream/sdk/browser'
import { ConnectTokenResponse } from 'sprites-types/api/pipedream'
import { ApiUser } from 'sprites-types/api/users'

export const pipedreamClient = createFrontendClient()

export function getPipedreamClient(user: ApiUser) {
  return createFrontendClient({
    externalUserId: user.id,
    tokenCallback: async () => {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v1/pipedream/getToken`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )

      const connectTokenResponse = await response.json()

      console.log(
        `[Pipedream] ConnectPipedreamIntegration getToken: ${JSON.stringify(connectTokenResponse)}`
      )

      return connectTokenResponse satisfies ConnectTokenResponse
    },
  })
}

async function connectPipedreamIntegration(appSlug: string): Promise<string | null> {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v1/pipedream/getToken`,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  console.log(`[Pipedream] ConnectPipedreamIntegration getToken: ${response !== undefined}`)

  const connectTokenResponse = (await response.json()) satisfies ConnectTokenResponse

  if (response.ok && connectTokenResponse.token) {
    const id = await new Promise<string | null>(async (resolve) => {
      await pipedreamClient.connectAccount({
        token: connectTokenResponse.token,
        app: appSlug,
        oauthAppId: getOAuthAppId(appSlug) ?? undefined,
        onSuccess: ({ id }) => {
          console.log(`[Pipedream] Connected with accountId \`${id}\``)
          resolve(id)
        },
        onError: (err) => {
          console.error(`[Pipedream] Error connecting to pipedream: ${err}`)
          resolve(null)
        },
        onClose: () => {
          resolve(null)
        },
      })
    })

    if (id) {
      return id
    }
  } else {
    console.error(`[Pipedream] Error getting pipedream connect token: ${response.status}`)
  }

  return null
}

function getOAuthAppId(appSlug: string): string | null {
  const appOAuthMap: Record<string, string> = {
    // google_drive: 'oa_NjiKmy', // Disabled until we get OAuth approval
  }

  return appOAuthMap[appSlug] ?? null
}

export { connectPipedreamIntegration }
